import SingleLineEllipsis from '@deltek/specification-client/core/Feedbacks/SingleLineEllipsis'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    propertiesHeaderLower: {
        height: '8%',
        backgroundColor: '#24CEAD',
    },
    propertiesHeaderLowerItem: {
        height: '100%',
        padding: theme.spacing(1.25),
    },
    propertiesHeaderLowerLeftSide: {
        ...theme.typography.subtitle1,
        color: theme.palette.common.white,
        fontWeight: 'bold',
    },
    propertiesHeaderLowerRightSide: {
        fontSize: pxToRem(13),
        color: theme.palette.common.white,
        fontWeight: 'bold',
    },
}))

interface RightSideHeaderLowerProps {
    loading?: boolean
    count?: number
}

export const RightSideHeaderLower: React.FC<RightSideHeaderLowerProps> = ({
    loading,
    count = 0,
}) => {
    const classes = useStyles()

    return (
        <GridContainer className={classes.propertiesHeaderLower} item>
            <GridContainer
                item
                xs={6}
                justifyContent="flex-start"
                alignItems="center"
                className={classes.propertiesHeaderLowerItem}
            >
                {!loading ? (
                    <SingleLineEllipsis
                        className={classes.propertiesHeaderLowerLeftSide}
                        text="Select Your Properties:"
                    />
                ) : (
                    <Skeleton variant="text" animation="pulse" width={200} />
                )}
            </GridContainer>
            <GridContainer
                item
                xs={6}
                justifyContent="flex-end"
                alignItems="center"
                className={classes.propertiesHeaderLowerItem}
            >
                {!loading ? (
                    <SingleLineEllipsis
                        className={clsx(
                            'lblPropertiesSelectedCount',
                            classes.propertiesHeaderLowerRightSide
                        )}
                        text={`Selected Properties: ${count}`}
                    />
                ) : (
                    <Skeleton
                        data-testid="imgLoadingCount"
                        variant="text"
                        animation="pulse"
                        width={200}
                    />
                )}
            </GridContainer>
        </GridContainer>
    )
}
